import { Analysis } from 'common-spectrum';
import max from 'ml-array-max';
import mean from 'ml-array-mean';
import min from 'ml-array-min';
import sd from 'ml-array-standard-deviation';
import { pelletHardnessParseHitec } from 'physical-chemistry-parser';

export function fromHitec(dt0, res) {
  let analysis = new Analysis();
  const parsed = pelletHardnessParseHitec(dt0, res);

  let meta = {};
  for (let key in parsed.meta) {
    meta = { ...meta, ...parsed.meta[key] };
  }

  let iph = parsed.variables.y.data;
  let top10 = iph.sort((a, b) => b - a).slice(0, iph.length / 10);
  const cheminfo = {
    meta: {
      average50: {
        SI: mean(iph) / 100,
        unit: 'cN',
      },
      sd: {
        SI: sd(iph) / 100,
        unit: 'cN',
      },
      min: {
        SI: min(iph) / 100,
        unit: 'cN',
      },
      max: {
        SI: max(iph) / 100,
        unit: 'cN',
      },
      averageHardest10: {
        SI: mean(top10) / 100,
        unit: 'cN',
      },
      method: meta.QualityName,
    },
  };

  meta.cheminfo = cheminfo;

  analysis.pushSpectrum(
    {
      x: parsed.variables.x,
      y: parsed.variables.y,
    },
    {
      dataType: 'Individual pellet hardness',
      title: meta.Meta,
      meta,
    },
  );

  return analysis;
}
